import { doc, setDoc } from 'firebase/firestore';
import { IMetricHistorySetting } from '../../providers/settings/metricHistorySettingProvider';
import { userAsPromise } from '../../providers/userProvider';

/**
 * @description persists the users setting for metric history
 * @param settings
 */
export const saveMetricHistorySetting = async (
  settings: IMetricHistorySetting
): Promise<void> => {
  const user = await userAsPromise();

  return setDoc(
    doc(
      user.services.firestore,
      `userProfiles/${user.id}/settings/metricHistory`
    ),
    settings,
    { merge: true }
  );
};
